import { useEffect } from 'react';
import Prev from '../../Assets/Pagination/Prev.svg';
import Next from '../../Assets/Pagination/Next.svg';
import { formatDate } from '../../lib/utils/utils';

function DateRange({ dateRange, changeDateRange }) {
    const onPreviousClick = () => {
        const startDate = new Date(dateRange.startDate);
        // const endDate = new Date(dateRange.endDate);

        let newStartDate, newEndDate;

        if (startDate.getDate() === 1) {
            newEndDate = new Date(startDate.getFullYear(), startDate.getMonth(), 0, 23, 59, 59, 999);
            newStartDate = new Date(startDate.getFullYear(), startDate.getMonth() - 1, 16, 0, 0, 0, 0);
        }
        else {
            newEndDate = new Date(startDate.getFullYear(), startDate.getMonth(), 15, 23, 59, 59, 999);
            newStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1, 0, 0, 0, 0);
        }

        changeDateRange({
            startDate: newStartDate.toISOString(),
            endDate: newEndDate.toISOString()
        });
    }

    const onNextClick = () => {
        const startDate = new Date(dateRange.startDate);
        // const endDate = new Date(dateRange.endDate);

        let newStartDate, newEndDate;

        if (startDate.getDate() === 1) {
            newStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), 16, 0, 0, 0, 0);
            newEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0, 23, 59, 59, 999);
        }
        else {
            newStartDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1, 0, 0, 0, 0);
            newEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 15, 23, 59, 59, 999);
        }

        changeDateRange({
            startDate: newStartDate.toISOString(),
            endDate: newEndDate.toISOString()
        });
    }

    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();

        let startDate, endDate;

        if (currentDate.getDate() <= 15) {
            startDate = new Date(year, month, 1, 0, 0, 0, 0);
            endDate = new Date(year, month, 15, 23, 59, 59, 999);
        }
        else {
            startDate = new Date(year, month, 16, 0, 0, 0, 0);
            endDate = new Date(year, month + 1, 0, 23, 59, 59, 999);
        }

        changeDateRange({
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString()
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex items-center gap-4">
            <div
                className='p-[10px] gap-[10px] rounded-lg border border-[#F1F1F1] hover:bg-[#F5F5F5] size-8 flex items-center justify-center cursor-pointer'
                onClick={onPreviousClick}
            >
                <div className='size-4 flex items-center justify-center'>
                    <img className='bg-transparent select-none' src={Prev} alt="Prev" />
                </div>
            </div>

            <p className='select-none font-semibold text-sm text-[#121212] w-64 text-center'>{formatDate(dateRange.startDate)}-{formatDate(dateRange.endDate)}</p>

            <div
                className='p-[10px] gap-[10px] rounded-lg border border-[#F1F1F1] hover:bg-[#F5F5F5] size-8 flex items-center justify-center cursor-pointer'
                onClick={onNextClick}
            >
                <div className='size-4 flex items-center justify-center'>
                    <img className='bg-transparent select-none' src={Next} alt="Next" />
                </div>
            </div>
        </div>
    );
}

export default DateRange;
